var map = {
	"./collectui.com.png": "93b3",
	"./coronapanel.com.png": "bc46",
	"./coronareader.com.png": "4643",
	"./flatuicolors.com.png": "e046",
	"./learnemp.com.png": "347c",
	"./materialuicolors.co.png": "884d",
	"./old.thenews.im.png": "dd1c",
	"./pfolios.net.png": "00e1",
	"./thenews.im.png": "c452",
	"./thestacks.im.png": "2e4a",
	"./thestocks.im.png": "859f",
	"./usepanda.com.png": "d807"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a0c";